export default __webpack_public_path__ + "aa00d3e2f3d3f1a48e39dbdb303f9ee0.svg";